<ion-grid class="favoritos-info-modal-content">
  <ion-row>
    <ion-col>
      <!-- Subtítulo -->
      <ion-row class="ion-margin-bottom">
        <ion-text
          [translateFormatter]="texts?.subtitle"
          class="subtitle"
          color="getm-neutral-light"
        >
        </ion-text>
      </ion-row>
      <ion-row class="ion-margin-bottom">
        <!-- ¿Cómo ganar? -->
        <ion-text class="section-title" color="getm-neutral-light">
          {{ texts?.howToWinTitle }}
        </ion-text>
        <ion-text class="section-text" color="getm-neutral-light">
          {{ texts?.howToWinText }}
        </ion-text>
      </ion-row>

      <!-- ¿Cuáles son mis productos favoritos? -->
      <ion-row class="ion-margin-bottom">
        <ion-text class="section-title" color="getm-neutral-light">
          {{ texts?.favProductsTitle }}
        </ion-text>
        <ion-text class="section-text" color="getm-neutral-light">
          {{ texts?.favProductsText }}
        </ion-text>
      </ion-row>

      <!-- Tabla de estados del tag -->
      <ion-row class="tag-status-table ion-margin-bottom">
        <ion-col>
          <ion-row class="tag-status-row">
            <ion-col>
              <getm-tag-card-product
                [icon]="'getm-fav'"
                [label]="'Labels.favorites' | translate"
                [color]="'getm-category-gana-mas'"
                [fill]="'outline'"
                corners="tr bl"
              ></getm-tag-card-product>
            </ion-col>
            <ion-col class="tag-status-info">
              <ion-text class="tag-status-title">{{
                texts?.tagNotCompletedTitle
              }}</ion-text>
              <ion-text class="tag-status-subtitle">{{
                texts?.tagNotCompletedSubtitle
              }}</ion-text>
            </ion-col>
          </ion-row>
          <ion-row class="tag-status-row">
            <ion-col>
              <getm-tag-card-product
                [icon]="'getm-fav'"
                [label]="'Labels.favorites' | translate"
                [color]="'getm-category-gana-mas'"
                [fill]="'solid'"
                corners="tr bl"
              ></getm-tag-card-product>
            </ion-col>
            <ion-col class="tag-status-info">
              <ion-text class="tag-status-title">{{
                texts?.tagCompletedTitle
              }}</ion-text>
              <ion-text class="tag-status-subtitle">{{
                texts?.tagCompletedSubtitle
              }}</ion-text>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>

      <!-- Importante -->
      <ion-text class="important-text">
        <ion-text class="important-title">{{ texts?.importantTitle }}</ion-text>
        {{ texts?.importantText }}
      </ion-text>
    </ion-col>
  </ion-row>
</ion-grid>
